module.exports = __webpack_public_path__ + "img/unit4.6565597f.jpg";